var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
var AuthUserActivationComponent = /** @class */ (function (_super) {
    __extends(AuthUserActivationComponent, _super);
    function AuthUserActivationComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.statements = {
            acceptActivation: true,
            acceptSavingsMailing: true,
            acceptHealthMailing: true,
            acceptDecleration: false
        };
        return _this;
    }
    AuthUserActivationComponent.prototype.ngOnInit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2139' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2139 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        sessionStorage.setItem("currentWindow", "עדכון רישום אקטיבציה");
        sessionStorage.setItem("elasticCode", "2193");
        this.data = this.modalService.data;
        this.statements.acceptActivation = this.data ? this.data.showActivation : true;
        this.statements.acceptSavingsMailing = this.data ? this.data.showSavingsMailing : true;
        this.statements.acceptHealthMailing = this.data ? this.data.showHealthMailing : true;
    };
    AuthUserActivationComponent.prototype.submit = function (form) {
        var _this = this;
        var controls = this.inputsQuery.map(function (elm) { return elm; });
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        var checkbox = document.querySelector('input[type=checkbox]');
        if (element && controls.length > 1) {
            if (controls[0].ngControl.errors.pattern) {
                element = controls[0].elementRef.nativeElement;
            }
            else if (controls[0].ngControl.errors.required == null) {
                element = controls[1].elementRef.nativeElement;
            }
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        else if (!element && checkbox.classList.contains('ng-invalid')) {
            checkbox.setAttribute('aria-invalid', true);
            setTimeout(function () { return checkbox.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            this.serverError = null;
            //console.log("sent parametes", this.statements);
            this.authUserService.sendAuthData("UpdateActivation", __assign({}, this.statements, { email: form.value.email }))
                .subscribe(function (res) {
                _this.modalService.close(res.Details);
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    return AuthUserActivationComponent;
}(AuthBaseComponent));
export { AuthUserActivationComponent };
